import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-sms',
    templateUrl: './sms.component.svg',
    styleUrls: ['./sms.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsComponent {}
